import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {DevilsCrossRoadGameAssets} from "./DevilsCrossRoadGameAssets";
import {DCRoadDataGameData} from "./server/data/DCRoadData";
import {BelowStakeWinRestriction} from "./server/BelowStakeWinRestriction";
import {DevilsCrossRoadGameMode} from "./server/DevilsCrossRoadGameMode";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {DevilsCrossRoad} from "./DevilsCrossRoad";
import {DevilsCrossRoadSound} from "./sound/DevilsCrossRoadSound";


export class DCPromoPanelConfig implements PromoPanelGameConfiguration {

    constructor() {}

    /*
        FS triggered qith avalanche and meter:
        [["","","M1","M1","M1",""],["","L1,L2","","S","","M4"],["","S,L2","L1","","M2","S"],["","L1,L2","","M2","","M4"],["","","M4","S","M4",""],["","","","","",""]]
     */
    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "Devil's Crossroad",
            hasActionSpin: true,
            graphics: {backgroundTextureName: DevilsCrossRoadGameAssets.MAIN_GAME_BACKGROUND},
            getParsedData: (response: DCRoadDataGameData, bet: number, prevResponse: DCRoadDataGameData):ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFsTriggeredThisSpin(response), // Figure it out with method
                    totalSpinWinnings: this.getSpinWin(response),
                    isBigWin: this.isBigWin(response),
                    winType: (response.mode === DevilsCrossRoadGameMode.FREESPIN || response.mode === DevilsCrossRoadGameMode.SUPER_FREESPIN) ? WINTYPE.MULTIPLIER : WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank,

                }
                return parsedData;
            }
        };
    }

    private isFsTriggeredThisSpin(response: DCRoadDataGameData):boolean  {
        return (response.mode == DevilsCrossRoadGameMode.NORMAL || response.mode == DevilsCrossRoadGameMode.NORMAL_AVALANCHE) && (response.nextMode == DevilsCrossRoadGameMode.FREESPIN || response.nextMode == DevilsCrossRoadGameMode.SUPER_FREESPIN);
    }

    private getSpinWin(response: any): number {
        if (response.mode === DevilsCrossRoadGameMode.FREESPIN || response.mode === DevilsCrossRoadGameMode.SUPER_FREESPIN){
            //This should return the actual timesBet value, not the calculated money win.
            return DevilsCrossRoad.model.getTotalFsXwin() - DevilsCrossRoad.model.getTotalPreviousFsXwin();
            /// return response.bonusWinTimesBetAfter - response.bonusWinTimesBetBefore; Total value in previousCoinValues subtracted from new total
        }
        else {
            return response.totalSpinWinnings;
        }
    }

    private isBigWin(response:DCRoadDataGameData): boolean {
        let win = response.totalSpinWinnings;
        const lastBonusSpin = (response.mode == DevilsCrossRoadGameMode.FREESPIN || (response.nextMode == DevilsCrossRoadGameMode.FREESPIN) && response.nextMode === DevilsCrossRoadGameMode.NORMAL);

        if (response.wasFeatureBuy){
            const betPrice = BelowStakeWinRestriction.getBuyFeaturePrice();
            let winRatio: number = (win / betPrice);
            return winRatio >= 1;
        }

        let winRatio: number = (win / response.playedBetValue);

        if(lastBonusSpin) {
            return false;
        }

        return winRatio >= 15;
    }

    private getFeatureName(response: DCRoadDataGameData): string {
        if ((response.mode == DevilsCrossRoadGameMode.FREESPIN) || (response.nextMode == DevilsCrossRoadGameMode.FREESPIN)){
            return "REDEMPTION SPINS";
        }

        if ((response.mode == DevilsCrossRoadGameMode.SUPER_FREESPIN) || (response.nextMode == DevilsCrossRoadGameMode.SUPER_FREESPIN)){
            return "REDEMPTION SPINS UPGRADED";
        }

        return response.mode;
    }

    private isRoundComplete(response: DCRoadDataGameData): boolean {
        return (response.nextMode !== DevilsCrossRoadGameMode.NORMAL_AVALANCHE);
    }

    private isBonusEnd(response: DCRoadDataGameData): boolean {
        return (response.nextMode === DevilsCrossRoadGameMode.NORMAL) && (response.nextMode === DevilsCrossRoadGameMode.FREESPIN || response.nextMode === DevilsCrossRoadGameMode.SUPER_FREESPIN);
    }

    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if (trigger == ActionSpinSound.WIN){
            DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.AS_WIN});
        }
        else if (trigger == ActionSpinSound.BIG_WIN) {
            DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.AS_WIN_BIG});
        }
    }


}